import { Components, Theme } from '@mui/material/styles';

export const MuiListItem: Components<Theme>['MuiListItem'] = {
  styleOverrides: {
    padding: ({ theme }) => {
      return {
        padding: theme.spacing(8, 16),
      };
    },
  },
};

export const MuiList: Components<Theme>['MuiList'] = {
  styleOverrides: {
    root: ({ theme }) => {
      return {
        padding: theme.spacing(8, 0),
      };
    },
  },
};
